const nodeModifier = require('./nodeModifier');
const numberRegex = require('./numberRegex');

declare function unescape(s:string): string;

import { share } from '../share';

function builGuScHtml(phoneNumber, originalText) {
  return `<vg-is-dial data-dn='${phoneNumber}' title='Click to dial ${phoneNumber}'><vg-is-img></vg-is-img>${originalText}</vg-is-dial>`;
}

function parse(node) {
  const parent = node.parentNode;
  if (!parent) {
    return;
  }
  if (parent.className === '__gu') {
    return; // yield legacy
  }
  if (parent.matches) {
    if (parent.matches('[contenteditable="true"],[contenteditable="true"] *')) {
      return;
    // } else if (window.scContentExcludeSelectors.length && parent.matches(window.scContentExcludeSelectors.join(','))) {
    //   return;
    }
  }
  if (parent.parentNode && parent.parentNode.tagName === 'LIGHTNING-CLICK-TO-DIAL') {
    return;
  }
  if (parent.tagName === 'A' && /callto\:|tel\:/.test(parent.href)) {
    try { // Note: Do not use unescape to decode URIs, use decodeURI instead.
      let telLinkNumber = decodeURI(parent.href).split(':')[1];
      if (telLinkNumber.match(numberRegex)) {
        if (share.sendWorkerMessage) {
          share.sendWorkerMessage(
            { action: 'vPhoneNumberInfo', phoneNumber: telLinkNumber },
            (data) => {
              if (data && data.valid) {
                nodeModifier.replace(parent, builGuScHtml(data.localFormat, parent.textContent));
              }
            }
          )
        }
      }
    } catch(e) {} // although decodeURI throws exceptions
  } else {
    const promises: Array<Promise<unknown>> = [];
    let textContent = node.textContent;
    let matches: Array<string> = [];
    if (/^{.+\:.+}$|^\d{5}-\d{5}$/.test(textContent)) { // ignore text content that looks like json (bad technique used in some sites)
      return;
    }
    if (/^(\+)?[\d-\s\.\/]{8,16}$/.test(textContent)) { // the whole text is a single number candidate (faster check)
      matches.push(textContent.replace(/[\u200B-\u200D\uFEFF\r\n]/g, ''));
    } else { // mixed numbers with text
      matches = textContent.replace(/[\u200B-\u200D\uFEFF\r\n]/g, '').match(numberRegex);
    }
    if (!matches || matches.length < 1) {
      return;
    }
    if (parent.dataset && parent.dataset.vgProc === textContent) {
      return;
    }
    matches.forEach(function(match) {
      if (match.replace(/\D/g, '').length > 5) {
        // price exception because of NAC-223. Although 1.8443240340 is a valid number notation
        if (/^\d{1,2}\/\d{1,2}\/\d{2,4}$/.test(match) || /^\d*\.\d+$/.test(match) || !/\d+/.test(match)) {
          return; // date exteption, non digits string
        }
        if (parent.dataset) {
          parent.dataset.vgProc = textContent;
        }
        promises.push(
          new Promise(function (resolve) { // 'reject'; To explain unused parameter
            if (share.sendWorkerMessage) {
              share.sendWorkerMessage(
                { action: 'vPhoneNumberInfo', phoneNumber: match },
                (data) => {
                  if (data && data.valid) {
                    const replex = new RegExp('(' + match.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') + ')(?![^<]*>|[^<>]*<\/)');
                    textContent = textContent.replace(replex, builGuScHtml(data.localFormat, match));
                    resolve(true);
                  } else {
                    resolve(false);
                  }
                }
              )
            } else {
              resolve(false);
            }
          })
        );
      }
    });
    Promise.all(promises).then(function (result) {
      if (result.indexOf(true) !== -1) {
        if (parent.dataset) {
          delete parent.dataset.vgProc;
          if (window.getComputedStyle) {
            if (window.getComputedStyle(parent, null).getPropertyValue('text-overflow') === 'ellipsis') {
              parent.style.textOverflow = 'initial';
            }
          }
        }
        nodeModifier.replace(node, textContent);
      }
    });
  }
}

module.exports = {
  parse: parse
};